// The following is a very simple pub/sub implementation using custom window events

/**
 * Publishes information as a custom window event
 * @param {string} eventType The type of event to publish (e.g. MODULE_LAUNCH)
 * @param {object} eventPayload The payload being published.
 */
export const publish = (eventType, eventPayload) => {
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent('CONVERSION_CLOUD_EVENT', false, false, {
        type: eventType,
        payload: eventPayload
    });
    window.dispatchEvent(evt);
};

/**
 * Publishes information as a custom window event
 * @param {string} eventType The type of event to subscribe to (e.g. MODULE_LAUNCH)
 * @param {function} callback The callback to run when a subscribed to eventType is published.
 */
export const subscribe = (eventType, callback) => {
    window.addEventListener('CONVERSION_CLOUD_EVENT', evt => {
        const { payload, type } = evt.detail;

        if (eventType === type) {
            callback(payload);
        }
    });
};

/**
 * All of the possible events that can be published by the container and modules
 * PubSub should hold the contract for these events.
 */
export const Events = {
    EXCEPTION: 'EXCEPTION',
    GA_EVENT: 'GA_EVENT',
    CHATBOT_LOADED: 'CHATBOT_LOADED',
    CHATBOT_INTERACTED: 'chatbot_interacted',
    LEAD_CREATED: 'LEAD_CREATED',
    LEAD_ERROR: 'LEAD_ERROR',
    LEAD_UPDATED: 'LEAD_UPDATED',
    MODULE_CLOSED: 'MODULE_CLOSED',
    MODULE_OPENED: 'MODULE_OPENED',
    OPEN_MODULE: 'OPEN_MODULE',
    QUESTIONS_ANSWERED: 'QUESTIONS_ANSWERED',
    OFFERS_LOADED: 'OFFERS_LOADED'
};
